import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KEYS } from 'src/app/shared/utils/constants/storage.constants';
import { getBaseRequestData } from '../../../utils/evergentUtils';
import { ConfigService } from '../../config.service';
import { DeviceHandlerService } from '../../device-handler.service';
import { SessionService } from '../../session.service';
import {
  GenerateDeviceActivationCodeRequestMessage,
  GenerateDeviceCodeRequestModel,
} from './model/activation-code/device-activation-code.request.model';
import { GenerateDeviceActivationCodeResponseMessage } from './model/activation-code/device-activation-code.response.model';
import { ProductRequestMessage } from './model/product/product-request.message';
import { ProductRequestModel } from './model/product/product-request.model';
import { ProductResponseMessage } from './model/product/product-response.message';
import { applicationConstants } from 'src/app/shared/applicationConstants';

@Injectable()
export class SignUpService {
  private umsUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
    private readonly session: SessionService,
    private readonly deviceHandlerService: DeviceHandlerService
  ) {
    this.umsUrl = this.configService.applicationConfig.UmsURL;
  }

  generateDeviceActivationCode(): Observable<GenerateDeviceActivationCodeResponseMessage> {
    const url = `${this.umsUrl}/aha/generateDeviceActivationCode`;

    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-type': 'application/json',
    });

    const requestDeviceCodeMethods =
      new GenerateDeviceActivationCodeRequestMessage();
    const deviceDetails = {
      serialNo: '',
      deviceName: '',
      deviceType: '',
      modelNo: '',
      appType: '',
      location: '',
      userAgent: '',
    };
    let requestContent: GenerateDeviceCodeRequestModel =
      new GenerateDeviceCodeRequestModel();

    requestContent = {
      ...requestContent,
      ...getBaseRequestData(this.configService.applicationConfig),
    };

    if (navigator.userAgent.toString().includes('Web0S')) {
      deviceDetails.deviceName = applicationConstants.LG_DEVICE_NAME;
      deviceDetails.deviceType = applicationConstants.LG_DEVICE_NAME;
    } else {
      deviceDetails.deviceName = applicationConstants.SAMSUNG_DEVICE_NAME;
      deviceDetails.deviceType = applicationConstants.SAMSUNG_DEVICE_NAME;
    }

    deviceDetails.modelNo = '';
    deviceDetails.appType = applicationConstants.APP_TYPE;
    deviceDetails.location = '';
    deviceDetails.serialNo = this.deviceHandlerService.getCurrentDeviceID();
    try {
      deviceDetails.userAgent = JSON.parse(localStorage.getItem(KEYS.LOCATION))
        .city
        ? JSON.parse(localStorage.getItem(KEYS.LOCATION)).city
        : '';
    } catch (error) {
      console.warn(error);
    }
    requestContent.deviceDetails = deviceDetails;

    requestContent.channelPartnerID =
      this.configService.applicationConfig.evGlobalBU;
    requestDeviceCodeMethods.GenerateDeviceActivationCodeRequestMessage =
      requestContent;

    return this.http.post<GenerateDeviceActivationCodeResponseMessage>(
      url,
      requestDeviceCodeMethods,
      { headers }
    );
  }

  getProducts(): Observable<ProductResponseMessage> {
    const url = `${this.umsUrl}/aha/getProducts`;

    const headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.http.post<ProductResponseMessage>(
      url,
      this.getProductRequest(),
      { headers }
    );
  }

  private getProductRequest(): ProductRequestMessage {
    const requestMessage = new ProductRequestMessage();
    let requestContent = new ProductRequestModel();

    requestContent.dmaID = applicationConstants.DMA_ID;
    requestContent.returnAppChannels = applicationConstants.EVERGENT_TRUE;
    requestContent.returnPromotions = applicationConstants.EVERGENT_TRUE;
    requestContent.returnLocaleDisplayName = applicationConstants.EVERGENT_TRUE;
    requestContent = {
      ...requestContent,
      ...getBaseRequestData(this.configService.applicationConfig),
    };
    requestMessage.GetProductsRequestMessage = requestContent;

    return requestMessage;
  }
}
